/* eslint-disable */
import React from 'react';
import { InputAdornment, TextField as MuiTextField } from "@mui/material";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

export const DatePickerMobileWrapper = ({ input, inputOnBlur, ...other }: any) => {
    const inputProps = {
        ...input,
        onChange: (e: any) => {
            input.onChange(e);
            inputOnBlur && inputOnBlur(e);
        },
        ...other
    };

    const localeText: any = {
        cancelButtonLabel: "Cancelar",
        okButtonLabel: "Aceptar"
    }

    return <LocalizationProvider dateAdapter={AdapterMoment} locale={'es-MX'} localeText={localeText}>
        <MobileDatePicker
            {...inputProps}
            dayOfWeekFormatter={(day: string) => {
                switch (day) {
                    case "Sun":
                        day = "Dom";
                        break;
                    case "Mon":
                        day = "Lun";
                        break;
                    case "Tue":
                        day = "Mar";
                        break;
                    case "Wed":
                        day = "Mie";
                        break;
                    case "Thu":
                        day = "Jue";
                        break;
                    case "Fri":
                        day = "Vie";
                        break;
                    case "Sat":
                        day = "Sab";
                        break;
                }
                return day.charAt(0).toUpperCase();
            }}
            renderInput={(params: any) => {
                return <MuiTextField
                    {...params}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <CalendarTodayIcon />
                            </InputAdornment>
                        ),
                    }}
                    {...inputProps}
                />
            }}
            {...other}
        />
    </LocalizationProvider>
};

export default DatePickerMobileWrapper;